import { List, ListItem } from "@simplybusiness/mobius";
import type React from "react";
import type { QuestionProps } from "../../../../../../components/Questionnaire/Section/Question/types";

type SecondaryTextElementProps = {
  primaryQuestion: Partial<QuestionProps>;
  questions: Partial<QuestionProps>[];
  lastItemDisables?: boolean;
};

/**
 * Creates a secondary text element from an array of questions or falls back to original text.
 * Filters questions by visibility and excludeFromPrimaryText flag.
 */
export const SecondaryText = ({
  primaryQuestion,
  questions,
  lastItemDisables = false,
}: SecondaryTextElementProps): React.ReactElement | string => {
  // Exclude the last question if disabled, then filter to only visible questions
  const visibleQuestions = (
    lastItemDisables ? questions.slice(0, -1) : questions
  ).filter(question => question.visible && !question.excludeFromPrimaryText);

  if (visibleQuestions.length) {
    return (
      <List className="mobius-question__secondary-text">
        {visibleQuestions.flatMap((question, index) => {
          // For multiselect questions with options, show option labels as bullet points
          if (
            question.display?.type === "multiselect" &&
            question.options?.length
          ) {
            return question.options.map(option => (
              <ListItem key={`${question.id ?? index}-${option.value}`}>
                {option.label}
              </ListItem>
            ));
          }
          return (
            <ListItem key={question.id ?? index}>
              {question.primaryText}
            </ListItem>
          );
        })}
      </List>
    );
  }

  if (typeof primaryQuestion.secondaryText === "string") {
    return primaryQuestion.secondaryText;
  }

  return "";
};
